import { ApiPath } from '@/common/app/api-path';
import {
  // LotteryTicketType,
  type ApplyTicketRewardResponseType,
  type GetLotteryInfoResponseType,
  type LotterySeasonHistoryData,
  type LotteryWinnerInfo,
} from '@/common/types/lottery';

import { api } from '../base';

const lotteryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLotteryInfo: builder.query<GetLotteryInfoResponseType, void>({
      query: () => ApiPath.GET_LOTTERY_INFO,
      keepUnusedDataFor: 0,
    }),
    applyLotteryReward: builder.mutation<void, { ticketId: string }>({
      query: ({ ticketId }) => ({
        url: ApiPath.APPLY_LOTTERY_REWARD + ticketId,
        method: 'POST',
      }),
    }),
    getLotterySeasonsHistoryList: builder.query<
      LotterySeasonHistoryData[],
      { type: string }
    >({
      query: ({ type }) => ApiPath.GET_LOTTERY_HISTORY + type,
    }),
    getLotterySeasonHistoryWinners: builder.query<
      LotteryWinnerInfo[],
      { type: string; id: string }
    >({
      query: ({ type, id }) => ApiPath.GET_LOTTERY_HISTORY + type + '/' + id,
    }),
    applyTicketReward: builder.mutation<
      ApplyTicketRewardResponseType,
      { ticketId: string }
    >({
      query: ({ ticketId }) => ({
        url: ApiPath.APPLY_LOTTERY_REWARD + ticketId,
        method: 'POST',
      }),
    }),
    // startLottery: builder.mutation<void, void>({
    //   query: () => ({
    //     url: '/lottery/drow-lotteries',
    //     method: 'POST',
    //   }),
    // }),
    // createTicket: builder.mutation<
    //   void,
    //   { sourceCode: string; tier: LotteryTicketType }
    // >({
    //   query: (body) => ({
    //     url: '/lottery/create-ticket',
    //     method: 'POST',
    //     body,
    //   }),
    // }),
  }),
});

export const {
  useGetLotteryInfoQuery,
  useApplyLotteryRewardMutation,
  useGetLotterySeasonsHistoryListQuery,
  useGetLotterySeasonHistoryWinnersQuery,
  useLazyGetLotterySeasonHistoryWinnersQuery,
  useLazyGetLotteryInfoQuery,
  // useStartLotteryMutation,
  // useCreateTicketMutation,
  useApplyTicketRewardMutation,
} = lotteryApi;
export { lotteryApi };
